export const products = [
   {
      label: 'Bil',
      icon: 'bil1',
      count: 0,
      max: 3,
   },
   {
      label: 'Indbo',
      icon: 'indbo',
      count: 0,
      max: 1,
   },
   {
      label: 'Ulykke&nbsp;& Sundhed',
      icon: 'ulykke',
      count: 0,
      max: 2,
   },
   {
      label: 'Hus',
      icon: 'hus',
      count: 0,
      max: 1,
   },
   {
      label: 'Rejse',
      icon: 'rejse',
      count: 0,
      max: 1,
   },
   {
      label: 'MC,&nbsp;ATV&nbsp;& Knallert',
      icon: 'mc',
      count: 0,
      max: 2,
   },
   {
      label: 'Fritidshus',
      icon: 'fritid',
      count: 0,
      max: 1,
   },
   {
      label: 'Ejerskifte',
      icon: 'ejerskifteforsikring',
      count: 0,
      max: 1,
   },
   {
      label: 'Båd',
      icon: 'baad',
      count: 0,
      max: 1,
   },
   {
      label: 'Camping',
      icon: 'camping',
      count: 0,
      max: 2,
   },
   {
      label: 'Liv',
      icon: 'livsforsikring',
      count: 0,
      max: 2,
   },
   {
      label: 'Dyr',
      icon: 'dyr',
      count: 0,
      max: 3,
   },
   {
      label: 'Lønsikring',
      icon: 'lonsikring',
      count: 0,
      max: 1,
   },
];

export const pages = [
   // Generelt
   {
      test: /^\/3-tilbud-paa-en-billig-forsikring\/?$/i,
      title: 'Få 3 gratis tilbud på<br>en god og billig forsikring.',
      icon: null,
   },
   {
      test: /^\/3-tilbud-paa-en-billig-forsikring-ny-formular\/?$/i,
      title: 'Få 3 gratis tilbud på<br>en god og billig forsikring.',
      icon: null,
      useNewForm: true,
   },
   {
      test: /^\/3-tilbud-paa-en-billig-forsikring-adservice/i,
      title: 'Få 3 gratis tilbud på<br>en god og billig forsikring.',
      icon: null,
   },
   {
      test: /^\/3-tilbud-paa-en-billig-forsikring-fra-forsikringsselskaber/i,
      title: 'Få 3 forsikringstilbud på<br>en billig forsikring fra forsikringsselskaber.',
      icon: null,
   },
   {
      test: /^\/faa-3-gratis-tilbud-og-find-den-billigste-forsikring/i,
      title: 'Få 3 gratis tilbud og find<br>den billigste forsikring.',
      icon: null,
   },
   {
      test: /^\/3-forsikringstilbud-paa-en-billig-forsikring/i,
      title: 'Få 3 forsikringstilbud<br>på en billig forsikring.',
      icon: null,
   },
   {
      test: /^\/faa-3-gratis-tilbud-og-find-billige-forsikringer/i,
      title: 'Få 3 gratis tilbud og<br>find billige forsikringer.',
      icon: null,
   },
   {
      test: /^\/3-tilbud-paa-forsikringer\/?$/i,
      title: 'Få 3 gratis tilbud på<br>billige forsikringer.',
      icon: null,
   },
   {
      test: /^\/start/i,
      title: 'Vælg flere forsikringstyper og spar endnu mere.',
      icon: null,
      component: 'select-more-form',
      form_only: true,
      header_opaque: true,
      props: {},
   },
   // Bil
   {
      test: /^\/3-tilbud-paa-en-billig-bilforsikring/i,
      title: 'Få 3 tilbud på din bilforsikring.',
      icon: 'bil1',
   },
   {
      test: /^\/3-tilbud-paa-billigste-bilforsikring/i,
      title: 'Få 3 tilbud på den billigste bilforsikring.',
      icon: 'bil1',
   },
   {
      test: /^\/billig-bilforsikring-faa-3-gratis-tilbud-2/i,
      title: 'Få 3 tilbud på den billigste bilforsikring.',
      icon: 'bil1',
      component: 'alt-car-form-new',
      header_opaque: true,
   },
   // Indbo
   {
      test: /^\/3-tilbud-paa-en-billig-indboforsikring/i,
      title: 'Få 3 tilbud på din indboforsikring.',
      icon: 'indbo',
   },
   // Hus
   {
      test: /^\/3-tilbud-paa-en-billig-husforsikring/i,
      title: 'Få 3 tilbud på din husforsikring.',
      icon: 'hus',
   },
   {
      test: /^\/3-tilbud-paa-en-billig-villaforsikring/i,
      title: 'Få 3 tilbud på din villaforsikring.',
      icon: 'hus',
   },
   {
      test: /^\/3-tilbud-paa-en-billig-raekkehusforsikring/i,
      title: 'Få 3 tilbud på din rækkehusforsikring.',
      icon: 'hus',
   },
   // Ulykke
   {
      test: /^\/3-tilbud-paa-en-billig-ulykkesforsikring/i,
      title: 'Få 3 tilbud på din ulykkesforsikring.',
      icon: 'ulykke',
   },
   {
      test: /^\/3-tilbud-paa-en-billig-borneulykkesforsikring/i,
      title: 'Få 3 tilbud på din børneulykkesforsikring.',
      icon: 'ulykke',
   },
   // Fritid/sommerhus
   {
      test: /^\/3-tilbud-paa-en-billig-sommerhusforsikring/i,
      title: 'Få 3 tilbud på din sommerhusforsikring.',
      icon: 'fritid',
   },
   {
      test: /^\/3-tilbud-paa-en-billig-fritidshusforsikring/i,
      title: 'Få 3 tilbud på din fritidshusforsikring.',
      icon: 'fritid',
   },
   // Rejse
   {
      test: /^\/3-tilbud-paa-en-billig-rejseforsikring/i,
      title: 'Få 3 tilbud på din rejseforsikring.',
      icon: 'rejse',
   },
   // Ejerskifte
   {
      test: /^\/3-tilbud-paa-en-billig-ejerskifteforsikring/i,
      title: 'Få 3 tilbud på din ejerskifteforsikring.',
      icon: 'ejerskifteforsikring',
   },
   // Båd
   {
      test: /^\/3-tilbud-paa-en-billig-baadforsikring/i,
      title: 'Få 3 tilbud på din bådforsikring.',
      icon: 'baad',
   },
   // Liv
   {
      test: /^\/3-tilbud-paa-en-billig-livsforsikring/i,
      title: 'Få 3 tilbud på din livsforsikring.',
      icon: 'livsforsikring',
   },
   // Camping
   {
      test: /^\/3-tilbud-paa-en-billig-campingforsikring/i,
      title: 'Få 3 tilbud på din campingforsikring.',
      icon: 'camping',
   },
   // Dyr
   {
      test: /^\/3-tilbud-paa-en-billig-hesteforsikring/i,
      title: 'Få 3 tilbud på din hesteforsikring.',
      icon: 'dyr',
   },
   {
      test: /^\/3-tilbud-paa-en-billig-hundeforsikring/i,
      title: 'Få 3 tilbud på din hundeforsikring.',
      icon: 'dyr',
   },
   // MC
   {
      test: /^\/3-tilbud-paa-en-billig-mc-knallert-eller-scooterforsikring/i,
      title: 'Få 3 tilbud på din MC,<br>ATV & Knallertforsikring.',
      icon: 'mc',
   },
   // Video
   {
      test: /3-tips-til-den-bedste-forsikring/i,
      subtitle: 'Se videoen og bliv klædt godt på, til du får dine forsikringstilbud',
      icon: null,
      header_opaque: true,
      component: 'wistia-block',
      props: {
         videoId: 'ck0b0qugek',
         title: '3 tips til hvordan du får den bedste forsikring',
         style: {
            backgroundColor: 'var(--ff-stripe-bg)',
         },
      },
   },
   {
      test: /gfforsikring-gsr234dsaf/i,
      subtitle: 'Se videoen og bliv klædt godt på, til du får dine forsikringstilbud',
      icon: null,
      header_opaque: true,
      component: 'wistia-block',
      props: {
         videoId: 'lh9k4238bh',
         title: 'GF Forsikring samarbejde med Findforsikring',
         style: {
            backgroundColor: 'var(--ff-stripe-bg)',
         },
      },
   },
   // Stats
   {
      test: /^\/undersogelse\/?$/i,
      title: 'Få 3 gratis tilbud på<br>en god og billig forsikring.',
      icon: null,
      component: 'findforsikring-stats-jumbo',
   },
];

export const breakPoints = {
   xxl: 1400,
   xl: 1200,
   lg: 992,
   md: 768,
   sm: 576,
   xs: 0,
};

export const loadAsync = (url) => {
   const elm = document.createElement('script');
   elm.src = url;
   elm.async = true;
   document.head.appendChild(elm);
};
